<template>
  <booking-section id="services" :title="`Weitere Leistungen`" contentClass="" @section-clicked="sectionClicked" contentClass="" :collapsed="moduleCollapsed">
    <div class="booking__services" id="booking_services_table" v-if="loaded">
      <div class="spacer">
        <div v-for="(data, di) in result.services"  v-if="true == false">
          <div class="booking__title clickable" @click="toggleSection(data.id)" v-if="data.values.length > 0">
            <h3 :class="`${(di != 0) ? 'selectable-services-header' : ''} product-list-description`">
              <span class="services-counter" v-if="di != 0">{{ di }}.)</span>
              {{ data.name.replace(/[0-9]{1,}\./, '') }}
              <div v-if="di != 0" class="arrow-indicator close"></div>
            </h3>
          </div>
          <div  class="row services-section" :id="data.id">
            <div :class="`small-12 columns ${ di == 0 ? 'medium-12 large-12' : 'medium-4 large-4' }`" v-for="service in data.values">
              <div class="booking-element">
                <div class="row white-bg">
                  <div :class="`small-12 columns ${ di == 0 ? 'medium-4 large-4' : 'medium-12 large-12' }`">
                    <div class="booking__extra__img">
                      <img :src="service.picture_url">
                    </div>
                  </div>
                  <div :class="`small-12 columns ${ di == 0 ? 'medium-8 large-8' : 'medium-12 large-12' }`">
                    <div class="text-gold">
                      <b>{{service.name}}</b>
                    </div>

                    <div v-html="service.description" :class="!service.mandatory ? 'services-description' : ''"></div>
                    <div class="price-display text-right spacer-small" v-if="!service.mandatory  && di != 0">
                      <div class="teaser">
                        <b v-if="service.price == '0,00'">kostenfrei</b>
                        <b v-else>{{service.price}} EUR</b>
                      </div>
                      <div>
                        {{service.amount_type.join(", ")}}, {{ service.person_details }}
                      </div>
                      <div class="metainfo text-right" v-for="(kid) in service.kids_prices">
                        Kind {{kid.name}} - {{kid.price}} EUR
                      </div>
                    </div>
                    <div v-if="!service.mandatory && di != 0">
                      <input type="number" min="0" class="underline" v-if="service.booking_type == 'per_amount'" v-model="service.amount">
                      <a class="cta cta--inline cta--dark" v-if="isSelected(service.id)" @click="removeService(service.id)">Entfernen</a>
                      <a class="cta cta--inline cta" v-else @click="addService(service.id, (service.booking_type == 'per_amount' ? +service.amount : 1))">Wählen</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="booking__title" v-if="di == 0">
            <h3>Zubuchbare Leistungen</h3>
          </div>

        </div>
        <div class="booking__title clickable" @click="toggleSection('insurance')">
          <h3>{{ result.insurance.content.title }}</h3>
        </div>
        <div class="row">
          <div class="column small-12  medium-6">
            <a class="cta cta--dark" @click="insuranceVisble = true">Ich möchte eine Reiserücktrittsversicherung abschließen</a>
          </div>
          <div class="column small-12 medium-6 spacer">
            <a class="cta" @click="sendBookingProceed()">Ich verzichte auf eine Reiserücktrittsversicherung</a>
          </div>
        </div>
        <div id="insurance" style="display: none;" v-if="insuranceVisble">
          <div v-html="result.insurance.content.text" class="small"></div>
          <div class="row spacer">
            <div class="small-12 medium-12">
              <p class="spacer--top">Bitte geben Sie die Anzahl der mitreisenden Personen mit einem Alter über 64 Jahren an um sich die passenden Versicherungstarife anzuzeigen:</p>
            </div>
            <div class="small-12 medium-12">
              <input type="number" min="0" class="underline" :max="result.global.details.adults" v-model="seniors" @change="getInsurance()">
              <a class="cta cta--inline cta--white" @click="getInsurance()">Verfügbare Tarife anzeigen</a>
            </div>
          </div>
          <div class="row" v-if="noInsurance != true">
            <div class="small-12 booking-element" v-if="result.insurance.plans" :key="result.insurance.plans.length">
              <div id="insurance-container">
                <div class="spacer" v-for="plan in result.insurance.plans">
                  <div class="row plan">
                    <div class="column small-12 medium-4">
                      <div class="text-gold"><b>{{plan.productName}}</b></div>
                      <p class="text-xsmall">
                        <i class="small spacer-small" v-html="plan.description"></i>
                        <a :href="plan.detailsUrl" v-if="plan.description.match(plan.detailsUrl) == null" class="text-small">Produktinformationen</a>
                      </p>
                    </div>

                    <div class="column small-6 medium-4 text-right">
                      <div class="teaser">
                        {{plan.formattedPriceWithoutOwnRisk}}&nbsp;EUR<br /><span class="text-xsmall">(ohne Selbstbehalt)</span>
                      </div>
                      <a class="cta cta--dark" v-if="selectedInsuranceId && selectedInsuranceId == `${plan.id}.false`" @click="removeInsurance()">Entf.</a>
                      <div class="text-right" v-else-if="selectedInsuranceId == null"><a class="cta cta cta--inline cta--white" @click="selectInsurance(plan, false, null)">Wählen</a></div>
                    </div>
                    <div class="column small-6 medium-4 text-right">
                      <div class="teaser">{{plan.formattedPriceWithOwnRisk}}&nbsp;EUR<br /><span class="text-xsmall">(mit&nbsp;20%&nbsp;Selbstbehalt)</span></div>
                      <a class="cta cta--dark" v-if="selectedInsuranceId && selectedInsuranceId == `${plan.id}.true`" @click="removeInsurance()">Entf.</a>
                      <div class="text-right" v-else-if="selectedInsuranceId == null"><a class="cta cta cta--inline cta--white" @click="selectInsurance(plan, true, null)">Wählen</a></div>
                    </div>
                  </div>

                  <div class="row option" v-for="planOpt in plan.options">
                    <div class="column small-12 medium-4">
                      <b>inkl. {{planOpt.productName}}</b><br>
                      <p class="text-xsmall">
                        <i class="small spacer-small" v-html="planOpt.description"></i>
                        <a :href="plan.detailsUrl" v-if="planOpt.description.match(planOpt.detailsUrl) == null" >Produktinformationen</a>
                      </p>

                    </div>

                    <div class="column small-6 medium-4 text-small text-right">
                      <div class="teaser">
                        {{planOpt.formattedPriceWithoutOwnRisk}}&nbsp;EUR<br /><span class="text-xsmall">(ohne Selbstbehalt)</span>
                      </div>
                      <a class="cta cta--dark" v-if="selectedInsuranceId && selectedInsuranceId == `${planOpt.id}.false`" @click="removeInsurance()">Entf.</a>
                      <div class="text-right" v-else-if="selectedInsuranceId == null"><a class="cta cta cta--inline cta--white" @click="selectInsurance(plan, false, planOpt)">Wählen</a></div>
                    </div>
                    <div class="column small-6 medium-4 text-small text-right">
                      <div class="teaser">{{planOpt.formattedPriceWithOwnRisk}}&nbsp;EUR <br /><span class="text-xsmall">(mit&nbsp;20%&nbsp;Selbstbehalt)</span></div>
                      <a class="cta cta--dark" v-if="selectedInsuranceId && selectedInsuranceId == `${planOpt.id}.true`" @click="removeInsurance()">Entf.</a>
                      <div class="text-right" v-else-if="selectedInsuranceId == null"><a class="cta cta cta--inline cta--white" @click="selectInsurance(plan, true, planOpt)">Wählen</a></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="booking-element" v-if="insuranceVisble">
        <loader v-if="reloading" title="Ergebnis wird geladen" details="Einen Moment bitte"></loader>
        <div class="booking__prices sans-serif" v-else>

          <div class="row price-details-entry" v-if="selectedInsurance">
              <div class="columns large-5 medium-5 small-12 is-bootybox-col">Gewählte Versicherung</div>
              <div class="columns large-5 medium-5 small-12 is-bootybox-col">
                {{ selectedInsurance.plan.productName }}<br/>
                <span v-if="selectedInsurance.opt">
                  inkl. {{ selectedInsurance.opt.productName }} <br/>
                </span>
              </div>
          </div>
        </div>
        <a class="cta" @click="sendBookingProceed()">Buchung abschließen</a>
      </div>
    </div>

    <loader v-else title="Verfügbare Serviceleistungen werden geladen" details="Einen Moment bitte"></loader>
  </booking-section>
</template>

<script>

import axios from 'axios'
import resultLoader from '../booking/mixins/resultLoader'
import bookingDefaults from '../booking/mixins/bookingDefaults'
import checkout from '../booking/mixins/checkout'

export default {
  mixins: [resultLoader, bookingDefaults, checkout],
  watch: {
    resultData: {
      handler(res){
        this.pricesTable = this.result.prices_table
        this.price = this.result.results[0].price_display
      }
    },
    loaded: {
      handler(){
        this.getInsurance()
      }
    }
  },
  data(){
    return {
      currentStep: 'services',
      selected: [],
      pricesTable: '',
      price: '',
      reloading: false,
      selectedInsuranceId: null,
      selectedInsurance: null,
      noInsurance: null,
      seniors: 0,
      insuranceVisble: false
    }
  },
  computed: {
    seniorsDropdownValues(){
      var vals = []
      var s = 0
      for (s = 0; s <= this.result.global.details.adults; s++) {
        vals.push([{id: s, name: s}])
      }
      return vals
    }
  },
  methods: {
    isSelected(id){
      return (this.selected.findIndex(i => i == id) > -1)
    },
    addService(id, n){
      if (n == 0){
        alert("Bitte wählen Sie die gewünschte Anzahl aus.")
      }else{
        this.selected.push(id)
        this.result.calculation_data.forEach((data,i) => {
          this.result.calculation_data[i].services[id] = n
        })
        this.recalculate()
      }
    },
    removeService(id){
      const i = this.selected.findIndex(s => s == id)
      this.selected.splice(i,1)
      this.result.calculation_data.forEach((data,i) => {
        this.result.calculation_data[i].services[id] = null
      })
      this.recalculate()
    },
    selectInsurance(plan, ownRisk = false, opt = null){
      if (opt){
        this.selectedInsuranceId = `${opt.id}.${ownRisk}`
      }else{
        this.selectedInsuranceId = `${plan.id}.${ownRisk}`
      }

      this.selectedInsurance = { plan: plan, ownRisk: ownRisk, opt: opt }
      this.noInsurance = false
      this.result.calculation_data.forEach((data,i) => {
        this.result.calculation_data[i].insurance_id = this.selectedInsuranceId
        this.result.calculation_data[i].insurance = this.selectedInsurance
      })
      this.recalculate()
    },
    removeInsurance(){
      this.selectedInsuranceId = null
      this.selectedInsurance = null
      this.noInsurance = null
      this.result.calculation_data.forEach((data,i) => {
        this.result.calculation_data[i].insurance_id = this.selectedInsuranceId
        this.result.calculation_data[i].insurance = this.selectedInsurance
      })
      this.recalculate()
    },
    recalculate(){
      this.reloading = true
      axios.post(`${process.env.BASE_URL}/api/booking/${this.productId}/recalculate`, {
        calculation_data: JSON.stringify(this.result.calculation_data)
      })
      .then(response => {
        this.pricesTable = response.data.prices_table
        this.price = response.data.results[0].price_display
        this.$emit('update-summary', response.data)
        this.reloading = false
      })
    },
    getInsurance(){
      axios.get(`${process.env.BASE_URL}/api/booking/${this.productId}/get_insurance`, { params:
        Object.assign({ seniors: this.seniors }, this.result.global.details)
      }).
      then(r => {
        this.result.insurance.plans = r.data.insurance.plans
      })
    },
    toggleSection(id){
      $(`#${id}.services-section`).slideToggle()
      $(`#${id}.services-section`).parent().find('.arrow-indicator').toggleClass('close')
    }
  }
}
</script>

<style lang="scss" scoped>


  #insurance table tr.plan td { border-top: solid 1px #000; padding-bottom: 15px;}
  #insurance table tr.plan:first-child td { border-top: none; }

  #insurance td .cta { margin-left: 30px; }
  #insurance i a { font-weight: bold; }
</style>